import styled, {css} from "styled-components";
import {ListItemType} from "./ListItem";

export const List = styled.div`
  width: 100%;
`

export const ListItem = styled.div<ListItemType>`
  ${({active, theme}) => active
    ? 
    css`
      background: ${theme.colors.red};
      color: white;
    `
    :
    css`
      background: #E0E0E080;
      color: black;
      border: solid 1px #E0E0E080;
      &:hover {
        border: solid 1px #B3376C;
      }
    `
  };  
  margin: 5px 0;
  border-radius: 33px;
  padding: 20px;
  font-family: ${({theme}) => theme.font.family};
  font-style: normal;
  font-size: 22px;
  font-weight: 400;
  cursor: pointer;
`;